import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "modal-head" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "modal-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "modal-error"
}
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_8 = { class: "section" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mono" }
const _hoisted_11 = { class: "mono" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "mono" }
const _hoisted_14 = { class: "mono" }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "mono" }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "mono" }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { class: "mono" }
const _hoisted_21 = { class: "section" }
const _hoisted_22 = { class: "mono" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "mono" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "mono" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "mono" }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { class: "section" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 3 }
const _hoisted_35 = { class: "section" }
const _hoisted_36 = { class: "tx-list" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = {
  key: 4,
  class: "muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyableHex = _resolveComponent("CopyableHex")!
  const _component_TxLink = _resolveComponent("TxLink")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-backdrop",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
          }, [
            _createElementVNode("div", {
              class: "modal-card casino-card",
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": `game-detail-${_ctx.gameId}`
            }, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("h3", {
                  id: `game-detail-${_ctx.gameId}`
                }, "Game details", 8, _hoisted_3),
                _createElementVNode("button", {
                  class: "modal-close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                  "aria-label": "Close"
                }, "×")
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading…"))
                : (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.error), 1),
                      _createElementVNode("button", {
                        class: "retry",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
                      }, "Retry")
                    ]))
                  : (_ctx.details)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("section", _hoisted_8, [
                          _cache[11] || (_cache[11] = _createElementVNode("h4", null, "Outcome", -1)),
                          _createElementVNode("dl", null, [
                            _createElementVNode("div", null, [
                              _cache[3] || (_cache[3] = _createElementVNode("dt", null, "Status", -1)),
                              _createElementVNode("dd", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", _ctx.statusClass])
                                }, _toDisplayString(_ctx.details.status), 3)
                              ])
                            ]),
                            (_ctx.details.winner)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _cache[4] || (_cache[4] = _createElementVNode("dt", null, "Winner", -1)),
                                  _createElementVNode("dd", _hoisted_10, _toDisplayString(_ctx.details.winner), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _cache[5] || (_cache[5] = _createElementVNode("dt", null, "Tier (your stake)", -1)),
                              _createElementVNode("dd", _hoisted_11, _toDisplayString(_ctx.formatSats(_ctx.details.tier)) + " sats", 1)
                            ]),
                            (_ctx.details.houseStake !== null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _cache[6] || (_cache[6] = _createElementVNode("dt", null, "House stake", -1)),
                                  _createElementVNode("dd", _hoisted_13, _toDisplayString(_ctx.formatSats(_ctx.details.houseStake)) + " sats", 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _cache[7] || (_cache[7] = _createElementVNode("dt", null, "Pot", -1)),
                              _createElementVNode("dd", _hoisted_14, _toDisplayString(_ctx.formatSats(_ctx.potValue)) + " sats", 1)
                            ]),
                            (_ctx.details.payoutAmount !== null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _cache[8] || (_cache[8] = _createElementVNode("dt", null, "Payout", -1)),
                                  _createElementVNode("dd", _hoisted_16, _toDisplayString(_ctx.formatSats(_ctx.details.payoutAmount)) + " sats", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.rakeAmount > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _cache[9] || (_cache[9] = _createElementVNode("dt", null, "Rake", -1)),
                                  _createElementVNode("dd", _hoisted_18, _toDisplayString(_ctx.formatSats(_ctx.details.rakeAmount)) + " sats", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.roll !== null && _ctx.details.roll !== undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _cache[10] || (_cache[10] = _createElementVNode("dt", null, "Roll", -1)),
                                  _createElementVNode("dd", _hoisted_20, _toDisplayString(_ctx.details.roll), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("section", _hoisted_21, [
                          _cache[17] || (_cache[17] = _createElementVNode("h4", null, "Parameters", -1)),
                          _createElementVNode("dl", null, [
                            _createElementVNode("div", null, [
                              _cache[12] || (_cache[12] = _createElementVNode("dt", null, "Contract version", -1)),
                              _createElementVNode("dd", _hoisted_22, _toDisplayString(_ctx.details.contractVersion), 1)
                            ]),
                            (_ctx.details.oddsN !== null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _cache[13] || (_cache[13] = _createElementVNode("dt", null, "Odds range", -1)),
                                  _createElementVNode("dd", _hoisted_24, "[" + _toDisplayString(_ctx.details.oddsLo) + ", " + _toDisplayString(_ctx.details.oddsTarget) + ") / " + _toDisplayString(_ctx.details.oddsN), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.finalExpiration)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _cache[14] || (_cache[14] = _createElementVNode("dt", null, "finalExpiration", -1)),
                                  _createElementVNode("dd", _hoisted_26, _toDisplayString(_ctx.formatTime(_ctx.details.finalExpiration)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.exitDelay)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _cache[15] || (_cache[15] = _createElementVNode("dt", null, "Exit delay", -1)),
                                  _createElementVNode("dd", _hoisted_28, _toDisplayString(_ctx.details.exitDelay) + "s", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.emulatorPubkey)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _cache[16] || (_cache[16] = _createElementVNode("dt", null, "Emulator pubkey", -1)),
                                  _createElementVNode("dd", null, [
                                    _createVNode(_component_CopyableHex, {
                                      value: _ctx.details.emulatorPubkey
                                    }, null, 8, ["value"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("section", _hoisted_30, [
                          _cache[23] || (_cache[23] = _createElementVNode("h4", null, "Commitments", -1)),
                          _createElementVNode("dl", null, [
                            _createElementVNode("div", null, [
                              _cache[18] || (_cache[18] = _createElementVNode("dt", null, "Player hash", -1)),
                              _createElementVNode("dd", null, [
                                _createVNode(_component_CopyableHex, {
                                  value: _ctx.details.playerHash
                                }, null, 8, ["value"])
                              ])
                            ]),
                            (_ctx.details.playerSecret)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _cache[19] || (_cache[19] = _createElementVNode("dt", null, "Player preimage", -1)),
                                  _createElementVNode("dd", null, [
                                    _createVNode(_component_CopyableHex, {
                                      value: _ctx.details.playerSecret
                                    }, null, 8, ["value"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.houseSecret)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _cache[20] || (_cache[20] = _createElementVNode("dt", null, "House preimage", -1)),
                                  _createElementVNode("dd", null, [
                                    _createVNode(_component_CopyableHex, {
                                      value: _ctx.details.houseSecret
                                    }, null, 8, ["value"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.terminalState && (!_ctx.details.playerSecret || !_ctx.details.houseSecret))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[21] || (_cache[21] = [
                                  _createElementVNode("dt", null, "Reveals", -1),
                                  _createElementVNode("dd", { class: "muted" }, "Not yet recorded (pre-/commit failure or stalled)", -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            (!_ctx.terminalState)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [...(_cache[22] || (_cache[22] = [
                                  _createElementVNode("dt", null, "Reveals", -1),
                                  _createElementVNode("dd", { class: "muted" }, "Hidden until the game resolves or expires — both secrets become public knowledge in the on-chain sweep at that point.", -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("section", _hoisted_35, [
                          _cache[28] || (_cache[28] = _createElementVNode("h4", null, "Transactions", -1)),
                          _createElementVNode("dl", _hoisted_36, [
                            (_ctx.details.playerEscrow)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _cache[24] || (_cache[24] = _createElementVNode("dt", null, "Player escrow", -1)),
                                  _createElementVNode("dd", null, [
                                    _createVNode(_component_TxLink, {
                                      outpoint: _ctx.details.playerEscrow,
                                      network: _ctx.network
                                    }, null, 8, ["outpoint", "network"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.houseEscrow)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _cache[25] || (_cache[25] = _createElementVNode("dt", null, "House escrow", -1)),
                                  _createElementVNode("dd", null, [
                                    _createVNode(_component_TxLink, {
                                      outpoint: _ctx.details.houseEscrow,
                                      network: _ctx.network
                                    }, null, 8, ["outpoint", "network"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.resolveTxid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _cache[26] || (_cache[26] = _createElementVNode("dt", null, "Sweep (resolve)", -1)),
                                  _createElementVNode("dd", null, [
                                    _createVNode(_component_TxLink, {
                                      outpoint: { txid: _ctx.details.resolveTxid },
                                      network: _ctx.network
                                    }, null, 8, ["outpoint", "network"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.details.houseRefundTxid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _cache[27] || (_cache[27] = _createElementVNode("dt", null, "House refund", -1)),
                                  _createElementVNode("dd", null, [
                                    _createVNode(_component_TxLink, {
                                      outpoint: { txid: _ctx.details.houseRefundTxid },
                                      network: _ctx.network
                                    }, null, 8, ["outpoint", "network"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.hasAnyTx)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, "No transactions recorded yet."))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
            ], 8, _hoisted_1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}